(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('SeekingGender', SeekingGender);

    SeekingGender.$inject = ['$resource'];

    function SeekingGender ($resource) {
        var resourceUrl =  'api/seeking-genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
